'use client';
import { useState } from 'react';
import { useAuth } from '@/components/AuthProvider';
import { useTheme } from '@/components/ThemeProvider';

export default function LoginScreen() {
  const { login } = useAuth();
  const { theme, toggle } = useTheme();
  const [username, setUsername] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!username || !pass) return;
    setError('');
    setLoading(true);
    try {
      await login(username, pass);
    } catch (err) {
      setError(err.message || 'Error de autenticación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{
        background: 'var(--bg-0)',
        backgroundImage: 'radial-gradient(circle at 25% 50%, rgba(99,102,241,.09) 0%, transparent 50%), radial-gradient(circle at 75% 50%, rgba(52,211,153,.05) 0%, transparent 50%)',
      }}
    >
      <div className="w-[400px] rounded-2xl p-[42px_36px] text-center" style={{ background: 'var(--bg-2)', border: '1px solid var(--border)', boxShadow: '0 8px 30px rgba(0,0,0,0.2)' }}>
        {/* Logo */}
        <div className="flex justify-center mb-4">
          <svg width="44" height="44" viewBox="0 0 30 30" fill="none">
            <rect width="30" height="30" rx="8" fill="var(--accent)" />
            <path d="M8 10h14v10a2 2 0 01-2 2H10a2 2 0 01-2-2V10z" stroke="#fff" strokeWidth="1.8" />
            <path d="M12 7l3 3-3 3" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18 7l-2 3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </div>
        <div className="text-xs font-semibold uppercase tracking-[1.5px] mb-1" style={{ color: 'var(--text-2)' }}>TeVeCompras</div>
        <h1 className="text-[26px] font-bold mb-1" style={{ color: 'var(--text-0)' }}>Meli<span style={{ color: 'var(--accent)' }}>Pricing</span></h1>
        <p className="text-[13px] mb-6" style={{ color: 'var(--text-1)' }}>Gestión de precios para MercadoLibre</p>

        {error && (
          <div className="rounded-lg p-2.5 mb-4 text-[12.5px]" style={{ background: 'rgba(255,59,48,0.1)', border: '1px solid var(--red)', color: 'var(--red)' }}>
            {error}
          </div>
        )}

        <div className="text-left mb-3">
          <label className="block text-xs font-medium mb-1" style={{ color: 'var(--text-1)' }}>Usuario</label>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="usuario"
            autoComplete="username"
            className="w-full px-3.5 py-2.5 rounded-lg text-[13.5px] outline-none"
            style={{ background: 'var(--bg-elevated)', border: '1px solid var(--border)', color: 'var(--text-0)' }}
          />
        </div>
        <div className="text-left mb-5">
          <label className="block text-xs font-medium mb-1" style={{ color: 'var(--text-1)' }}>Contraseña</label>
          <input
            type="password"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            placeholder="••••••••"
            autoComplete="current-password"
            onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
            className="w-full px-3.5 py-2.5 rounded-lg text-[13.5px] outline-none"
            style={{ background: 'var(--bg-elevated)', border: '1px solid var(--border)', color: 'var(--text-0)' }}
          />
        </div>
        <button
          onClick={handleLogin}
          disabled={loading || !username || !pass}
          className="w-full py-2.5 rounded-lg text-[13.5px] font-medium text-white cursor-pointer transition-colors"
          style={{ background: 'var(--accent)', border: '1px solid var(--accent)', opacity: loading ? 0.6 : 1 }}
        >
          {loading ? 'Ingresando...' : 'Iniciar sesión'}
        </button>

        {/* Theme toggle */}
        <div className="flex justify-center mt-5">
          <button
            onClick={toggle}
            className="w-[34px] h-[34px] rounded-lg flex items-center justify-center transition-colors"
            style={{ background: 'var(--bg-elevated)', border: '1px solid var(--border)', color: 'var(--text-1)' }}
            title={theme === 'dark' ? 'Modo claro' : 'Modo oscuro'}
          >
            {theme === 'dark' ? (
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="5" /><line x1="12" y1="1" x2="12" y2="3" /><line x1="12" y1="21" x2="12" y2="23" /><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" /><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" /><line x1="1" y1="12" x2="3" y2="12" /><line x1="21" y1="12" x2="23" y2="12" /><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" /><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
              </svg>
            ) : (
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}